export default __webpack_public_path__ + "assets/images/3fc916da07fd3446b8f93d206b3cc8a9.png";